module.exports = __webpack_public_path__ + "img/c2_E.cf5fc00b.png";